// Readable file sizes, shared by everything that has to print one.
//
// This used to be a private method of FileExplorer.vue, where it served only the
// upload limits and the queue of the upload modal. The size column of the three
// listings needs the same figures, and two of those tables are DataTables whose
// render callbacks are plain functions with no component to reach into, so the
// formatting had to come out of the component.

const KB = 1024;
const MB = 1024 * KB;
const GB = 1024 * MB;

// The unit changes only once the figure would reach 1 of the next one, so a
// 210 KB file reads as "210 KB" and not as the blunter "0.2 MB". Below 10 the
// figure keeps one decimal, because there the decimal still carries meaning;
// above it the decimal only adds noise and the limits keep their round shape
// ("150 MB", not "150.0 MB").
export function formatSize (bytes) {
  if (bytes < KB) return `${bytes} B`;
  if (bytes < MB) return `${withScale (bytes / KB)} KB`;
  if (bytes < GB) return `${withScale (bytes / MB)} MB`;

  return `${withScale (bytes / GB)} GB`;
}

function withScale (figure) {
  return figure < 10 ? figure.toFixed (1) : Math.round (figure);
}

// The same, for a cell of a listing. A document has no size when it is a folder
// or when it was uploaded before the size was stored and the backfill has not
// reached it, and the column is left empty there rather than printing a "0 B"
// that would read as an empty file.
export function formatDocumentSize (value) {
  if (value === null || value === undefined || value === "") return "";

  const bytes = Number (value);
  if (!Number.isFinite (bytes) || bytes < 0) return "";

  return formatSize (bytes);
}
